export enum CreatePaymentTypes {
  PACS_008_US_DOMESTIC = 'pacs_008-us-domestic',
  // Add other payment types here
}
